import React, { useState, useEffect } from "react";
import {
  Menu, MenuItem,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Avatar,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  TextField,Popover,
  Autocomplete,
  Box, List, ListItem, ListItemText, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Popper, IconButton,
} from "@mui/material";
import {
  MoreVert as MoreVertIcon,
  Mail as MailIcon,
  Delete as DeleteIcon,
  ArrowForwardIosRounded as ArrowForwardIosRoundedIcon,
  ArrowBackIosRounded as ArrowBackIosRoundedIcon,
  ArrowDropDown,
  ContentCopyRounded,
  AttachFileRounded as AttachFileRoundedIcon
} from "@mui/icons-material";
import DateRangePicker from '../../components/DatePicker';
import GenericDialog from "../../components/GenericDialogBox/index";
import defaultProfileImage from "../../assets/landing_page/new/pro.jpeg";
import {InfoIcon, NoAccessIcon} from "../../utils/icon/Landing-Page/Icon";
import InfoIcon1 from "../../assets/landing_page/Icons/info.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPlanForShare } from "../../Slices/planslice";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
const ProjectSharePlan = () => {
    const [open1, setOpen1] = useState(false);
  const [accessType, setAccessType] = useState("no-access");
  const [prevAccessType, setPrevAccessType] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [planName, setPlanName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [planDescription, setPlanDescription] = useState("");
  const [uploadedFile, setUploadedFile] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [planId, setPlanId] = useState("");
  const [PlanData, setPlanData] = useState([]);
  const [userId, setUserId] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [subject, setSubject] = useState(`You've Been Invited to Join a Plan | PlanShare.ai`);
  const [email, setEmail] = useState([]);
  const [errors, setErrors] = useState({ subject: "", message: "", email: "" });
  const [file, setFile] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  const [message, setMessage] = useState("");
  const [userData, setUserData] = useState([]);
  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
  const cellStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    textAlign: "left",
  };
  const dataStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "10px",
    fontWeight: 500,
    lineHeight: "18px",
    textAlign: "left",
  };
  const formatDate = (dateString) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [planIdData, setPlanIdData] = useState(localStorage.getItem("planId") || "");
  const [selectedId, setSelectedId] = useState(null);
  const [planDetails, setPlanDetails] = useState([]);
  const handleActionOpen = (event, userId, userDetails) => {
    setSelectedId(userId);
    setPlanDetails(userDetails);
    setAnchorEl(event.currentTarget);
  };

  const [infoAnchorEl, setInfoAnchorEl] = useState(null);
  const [infoPopperOpen, setInfoPopperOpen] = useState(false);

  const handleMouseEnter = (event) => {
    setInfoAnchorEl(event.currentTarget);
    setInfoPopperOpen(true);
  };

  const handleMouseLeave = () => {
    setInfoPopperOpen(false);
  };
  const [sortBy, setSortBy] = useState("Sort");
  const [anchorSortEl, setAnchorSortEl] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const handleSortClick = (event) => {
    setAnchorSortEl(event.currentTarget);
  };

  const handleSortSelect = (criteria) => { 
    setAnchorSortEl(null);

    // Toggle order if the same criteria is selected, otherwise reset to ascending
    const newOrder = sortBy === criteria && sortOrder === "asc" ? "desc" : "asc";

    setSortBy(criteria);
    setSortOrder(newOrder);
};

const sortedUsers = [...userData].sort((a, b) => {
    let comparison = 0;

    if (sortBy === "Email ID") {
        comparison = (a.email || "").localeCompare(b.email || "");
    } 
    if (sortBy === "Name") {
        comparison = (a.user_name || "").localeCompare(b.user_name || "");
    } 
    if (sortBy === "Added on") {
        comparison = new Date(a.updatedAt || 0) - new Date(b.updatedAt || 0);
    }

    return sortOrder === "asc" ? comparison : -comparison;
});

const handleGenerateLink = async () => {
  try {
    // Case 1: Neither start nor end date selected - generate 48hrs range
    if (!dateRange.startDate && !dateRange.endDate) {
      const now = new Date();
      const endDate = new Date(now.getTime() + (48 * 60 * 60 * 1000));
      
      const payload = {
        plan_id: planId,
        from_date: now.toLocaleDateString('en-CA'),
        end_date: endDate.toLocaleDateString('en-CA'),
        plan_link: linkToCopy
      };

      const response = await http.post(
        `/master_service/full_access/access_link/update`,
        payload
      );

      if (response.status === 200) {
        toast.success("Link has been successfully copied");
      }
      return;
    }

    // Case 2: Only start date without end date
    if (dateRange.startDate && !dateRange.endDate) {
      toast.error("Please select an end date");
      return;
    }

    // Case 3: Only end date without start date
    if (!dateRange.startDate && dateRange.endDate) {
      toast.error("Please select a start date");
      return;
    }

    // Case 4: Both dates selected
    const payload = {
      plan_id: planId,
      from_date: dateRange.startDate.toLocaleDateString('en-CA'),
      end_date: dateRange.endDate.toLocaleDateString('en-CA'),
      plan_link: linkToCopy
    };

    const response = await http.post(
      `/master_service/full_access/access_link/update`,
      payload
    );

    if (response.status === 200) {
      toast.success("Link has been successfully copied");
    }
  } catch (error) {
    console.error("Error generating link:", error);
    toast.error("Failed to generate link");
  }
};
  
  const UserProfileCard = ( { users }) => {
    const profileSrc = users.profileImage && typeof users.profileImage === "string"
          ? users.profileImage
          : defaultProfileImage;
    return (
      <Box 
        display="flex" 
        gap={2} 
        justifyContent="flex-start"
        sx={{ 
          maxWidth: "100%", 
          overflowX: "auto", // Enables horizontal scrolling
          whiteSpace: "nowrap", // Prevents wrapping to a new row
          paddingBottom: "10px", // Prevents scrollbar from overlapping content
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Hides scrollbar in Chrome/Safari/Edge
        }}
      >
        {users.map((user, index) => (
          <Card
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "6px",
              width: 200, // Compact width
              height: 60, // Slightly increased height for better spacing
              boxShadow: 2,
              borderRadius: "6px",
              flexShrink: 0,
            }}
          >
            {/* Left Side - Profile Image */}
            <Avatar
              variant="square"
              src={profileSrc}
              alt={user.user_name}
              sx={{ width: 50, height: 50, marginRight: 0.6}}
              onError={(e) => { e.target.src = defaultProfileImage; }}
            />
  
            {/* Right Side - User Info */}
            <CardContent 
              sx={{ 
                flex: 1,
                padding: "4px",
                marginTop: "15px", 
                display: "flex", 
                flexDirection: "column",
                justifyContent: "center", // Moves text slightly down
              }}
            >
              <Typography 
                variant="body2" 
                fontWeight="bold"
                sx={{ wordBreak: "break-word", fontSize: "12px", marginBottom: "2px" }}
              >
                {user.user_name}
              </Typography>
              <Typography 
                variant="caption" 
                color="textSecondary" 
                sx={{ wordBreak: "break-word", fontSize: "10px" }}
              >
                {user.email}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  };
  

  const handleClose = () => {
    if (prevAccessType !== accessType) {
      setAccessType(prevAccessType); // Correct way to reset state
    }
    setOpen1(false);
  };
  const handleChangeAccess = async () => {
    setPrevAccessType(accessType);
    try {
      if (accessType === "no-access" || accessType === "full-access") {
        const orgUserId = localStorage.getItem("user_id");
        const parsedPlanId = parseInt(planId, 10);
        const parsedUserId = parseInt(userId, 10);
        const currentDate = new Date();
        const accessSendDate = currentDate.toISOString().split("T")[0];
        const accessSendTime = currentDate.toTimeString().split(" ")[0];
        // const accessType = newValue === 'no-access' ? 'no access' : 'full access';

        const payload = {
          org_user_id: userId,
          plan_id: planId,
          user_id: "",
          access_send_date: accessSendDate,
          access_send_time: accessSendTime,
          status: "Active",
          access_type: accessType === "no-access" ? "no_access" : "full_access",
        };

        const response = await http.post(
          `/master_service/create/ps_plan/acess`,
          payload
        );
        if (response.data.success === true) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                Plan Access Successfully Changes
              </div>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}>
                User permissions for the plan have been updated
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          setOpen1(false);
          // handleBackClick();
        }
      }
      else if (accessType === "limited-access") {
        const payload = {
          plan_id: planId,
          flag: "limited_access",
          
        };

        const response = await http.post(
          `/master_service/limited/access`,
          payload
        );
        if (response.status === 201) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                Plan Access Successfully Changes
              </div>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}>
                User permissions for the plan have been updated
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
        setOpen1(false);
        }
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };
    const handleCloseAction = () => {
    setAnchorEl(null);
  };

  const handleResendMail = async () => {
    try {
      const payload = {
        plan_id : planDetails.plan_id,
        mail_id : planDetails.email
    };
      const response = await http.post('/master_service/resend/mail/plan_access', payload);
      if (response.status === 200) {
        toast.success(
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "8px",
              }}>
              Mail Resent Successfully
            </div>
          </>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        handleCloseAction();
    }
   } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const handleDeleteUser = async () => {
    try {
      const payload = {
        plan_id : planDetails.plan_id,
        user_id : planDetails.user_id
    };
      const response = await http.post('/master_service/remove/user/plan_log', payload);
      if (response.status === 200) {
        toast.success(
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "8px",
              }}>
              User removed Successfully
            </div>
          </>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        getMailLog(planDetails.plan_id);
        handleCloseAction();
    }
   } catch (error) {
      console.error("Error fetching data", error);
    }
  };



  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id, isEdit, isView, isDelete, table, isShare } = useSelector(
    (state) => state.planslice
  );
  useEffect(() => {
    if (id && id !== planIdData) {
      setPlanIdData(id);
      localStorage.setItem("planId", id);
    }
  }, [id, planIdData]);

  // Fetch plan data when `planIdData` changes
  useEffect(() => {
    if (planIdData) {
      fetchPlanData(planIdData);
    }
  }, [planIdData]);
  useEffect(() => {
    if (
      (isEdit && id) ||
      (isView && id) ||
      (isDelete && id) ||
      (isShare && id)
    ) {
      fetchPlanData();
    }
  }, [id, isEdit, isView, isDelete, isShare]);

  const fetchPlanData = async () => {
    try {
      const response = await http.get(`/master_service/get_plan/${id || planIdData}`);
      if (response.status === 200) {
        const data = response.data;
        const cleanPlanName = data.plan_name
          ? data.plan_name.replace(/(^")|("$)/g, "")
          : "";
        const cleanCustomerName = data.customer_name
          ? data.customer_name.replace(/(^")|("$)/g, "")
          : "";
        const cleanUserId = data.user_id
          ? data.user_id.replace(/(^")|("$)/g, "")
          : "";

        setPlanData([data]);
        setPlanName(cleanPlanName);
        setCustomerName(cleanCustomerName);
        setPlanDescription(data.plan_description || "");
        setUploadedFileName(data.unload_file_Path || "");
        setUploadedFile(data.unload_file_Path || "");
        setPlanId(data.plan_id || "");
        setUserId(cleanUserId);
        const startDate = data.from_date ? new Date(data.from_date) : null;
        const endDate = data.end_date ? new Date(data.end_date) : null;
        
        setDateRange({
          startDate: startDate,
          endDate: endDate
        });
        setPrevAccessType(data.access_name === "no_access" ? "no-access" : "full_access" ? "full-access" : "limited_access" ? "limited-access" : " ");
        setAccessType(
          data.access_name === "no_access"
            ? "no-access"
            : data.access_name === "full_access"
              ? "full-access"
              : "limited-access"
        );
        setMessage(`Good news—${data.created_by} has added you to the plan ${data.plan_name} in PlanShare, with the role of team member. You now have access to this plan and can participate according to your assigned permissions.`);
        getMailLog(data.plan_id);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  useEffect(() => {
    if (planId) {
      getUsers();
    }
  }, [planId]);

  const getUsers = async () => {
    try {
      if (!planId) {
        console.warn("planId is missing, skipping API call.");
        return;
      }

      const response = await http.post("/master_service/limited/access/drop/down", {
        plan_id: planId
      });
      if (!Array.isArray(response.data)) {
        console.error("Unexpected response format:", response.data);
        return;
      }
      const emailList = response.data
        .filter((role) => role.email) // Ensure email exists
        .map((role) => ({
          label: role.email,
          value: role.email,
        }));
      setEmailOptions(emailList);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleAccessChange = async (event) => {
    setPrevAccessType(accessType);
    const newValue = event.target.value;
    setAccessType(newValue);
    setShowTable(false);
    setShowGrid(false);
    setOpen1(true);
  };

  const handleBackClick = () => {
    navigate("/home/shareplan");
    dispatch(setPlanForShare({ id: null, isShare: false }));
  };

  const handleAddMembersClick = () => {
    setShowTable((prev) => !prev);
  };
  const generateExpiryTimestamp = () => {
    const now = new Date();
    const expiryDate = new Date(now.getTime() + (48 * 60 * 60 * 1000)); // 48 hours from now
    return expiryDate.toISOString();
  };

  const linkToCopy = `https://app.planshare.ai/home/viewplan?id=${id}`;
  //const linkToCopy = `https://salmon-hill-031f39a00.4.azurestaticapps.net/home/viewplan?id=${id}`;
  //const linkToCopy = `http://localhost:3000/home/viewplan?id=${id}`;
  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to copy the link: ", error);
      });
  };

  const validateFields = () => {
    const newErrors = { subject: "", message: "", email: "" };
    let isValid = true;

    setErrors(newErrors);
    return isValid;
  };

  const handleSendInvite = async (email, subject, message, file) => {
    if (!validateFields()) {
      return;
    }
    const newErrors = {};

    // Validate email
    if (!email || email.length === 0) {
      newErrors.email = "Please enter at least one email address";
    }

    // Validate subject
    if (!subject || subject.trim() === "") {
      newErrors.subject = "Subject is required";
    }

    // Validate message
    if (!message || message.trim() === "") {
      newErrors.message = "Message is required";
    }

    // If there are any errors, set them and return
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear any existing errors
    setErrors({});
    if (email.some(e => emailOptions.find(opt => opt.value === e.value))) {
      try {
        const orgUserId = localStorage.getItem("user_id");
        const parsedPlanId = parseInt(planId, 10);
        const currentDate = new Date();
        const accessSendDate = currentDate.toISOString().split("T")[0];
        const accessSendTime = currentDate.toTimeString().split(" ")[0];
        const formData = new FormData();
  
        formData.append(`org_user_id`, orgUserId);
        formData.append('plan_id', planId);
        formData.append('mail_id', email.map((e) => e.value));
        formData.append('access_send_date', accessSendDate);
        formData.append(`access_send_time`, accessSendTime);
        formData.append('status', "Active");
        formData.append('access_type', "limited_access");
        formData.append('attachment', file);
        formData.append('content', message);
        formData.append('subject', subject);
  
        const response = await http.post(
          `/master_service/limited/access`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (response.status === 201) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                Invite Sent Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          getMailLog(planId);
          getUsers(planId);
          setEmail([]);
          setFile(null);
        }
      } catch (error) {
        console.error("Error sending invite", error);
      }
    }
    else {
      try {
        const payload = {
          user_name: email.length > 0 ? email.map((e) => e.value.split("@")[0]).join(", ") : "",
          email: email.length > 0 ? email.map((e) => e.value).join(", ") : "",
          plan_id: planId,
        };
        const response = await http.post(
          `/master_service/myplan/access/to/user/creation`, payload);
        if (response.status === 200) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                Invite Sent Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          getMailLog(planId);
          getUsers(planId);
          setEmail([]);
          setFile(null);
        }
      } catch (error) {
        console.error("Error sending invite", error);
      }
    }    
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleButtonClick = () => {
    document.getElementById("file-upload").click();
  };
  const handleAutocompleteChange = async (event, newValue) => {
    setEmail(
      newValue.map((item) =>
        typeof item === "string" ? { label: item, value: item } : item
      )
    );
  };

  const handleAutocompleteBlur = (event) => {
    const inputValue = event.target.value.trim();
  
    if (inputValue && !email.some((e) => e.value === inputValue)) {
      // If the input is valid and not already in the list, add it
      setEmail((prevEmails) => [
        ...prevEmails,
        { label: inputValue, value: inputValue },
      ]);
    }
  };


  const [mailTable, setMailTable] = useState([]);
  const getMailLog = async (data) => {
    try {
      const response = await http.post(
        "/master_service/getall/access_mail/log",
        { plan_id: planId || data }
      );

      if (response.status === 200) {
        setUserData(response.data);
        setMailTable(response.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "730px",
        width: "100%",
        backgroundColor: "#FAFAFA",
      }}>
      <div style={{ width: "100%", margin: "0 auto" }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Button onClick={handleBackClick}
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "14.52px",
              color :'black',
              textTransform: "none"
            }} >
            Share Plan
          </Button>
          <ArrowForwardIosRoundedIcon sx={{ fontSize: "12px" }} />
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "14.52px",
            }}>
            Plan:{planName}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={handleBackClick}>
            <ArrowBackIosRoundedIcon />
          </IconButton>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "left",
            }}>
            {planName}  <span style={{fontSize: "14px", fontWeight: 400 }}>({accessType.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())})</span>
          </Typography>
        </Box>
        <Typography variant='body2' color='textSecondary'>
          {planDescription}
        </Typography>
        <div style={{ position: "relative", display: "inline-block" }} onMouseLeave={handleMouseLeave}>
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "21px",
            textAlign: "left",
            marginTop: "20px",
            marginBottom: "5px",
          }}>
          Project Permission<IconButton onMouseEnter={handleMouseEnter} sx={{fontSize: 10 }}>
        <img src={InfoIcon1} alt="info" height="15px" width="15px" />
        </IconButton>
        </Typography>
        </div>
        <Popper open={infoPopperOpen} anchorEl={infoAnchorEl} placement="bottom-start" sx={{ zIndex: 1200 }}>
        <Paper elevation={3} sx={{ padding: "8px", borderRadius: "6px", backgroundColor: "#F2F5FA", }} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}>
          <Typography sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "5px" }}>
            About Permission
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary="1. No Access - Fully private, only you can access the plan." />
            </ListItem>
            <ListItem>
              <ListItemText primary="2. Full Access - Anyone can access the plan using the link." />
            </ListItem>
            <ListItem>
              <ListItemText primary="3. Limited Access - Only selected team members can access the plan." />
            </ListItem>
          </List>
        </Paper>
      </Popper>
        <RadioGroup row value={accessType} onChange={handleAccessChange}>
          <FormControlLabel
            value='no-access'
            control={
              <Radio
                sx={{
                  width: "14px",
                  height: "14px",
                  ml: "15px",
                  padding: "15px",
                  "&.Mui-checked": { color: "red" },
                  "& .MuiSvgIcon-root": { fontSize: "20px" },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "500",
                  fontFamily: "Inter, sans-serif",
                }}>
                No Access
              </Typography>
            }
          />
          <FormControlLabel
            value='full-access'
            control={
              <Radio
                sx={{
                  width: "14px",
                  height: "14px",
                  ml: "15px",
                  padding: "15px",

                  "&.Mui-checked": { color: "red" },
                  "& .MuiSvgIcon-root": { fontSize: "20px" },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "500",
                  fontFamily: "Inter, sans-serif",
                }}>
                Full Access
              </Typography>
            }
          />
          <FormControlLabel
            value='limited-access'
            control={
              <Radio
                sx={{
                  width: "14px",
                  height: "14px",
                  ml: "15px",
                  padding: "15px",

                  "&.Mui-checked": { color: "red" },
                  "& .MuiSvgIcon-root": { fontSize: "20px" },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "500",
                  fontFamily: "Inter, sans-serif",
                }}>
                Limited Access
              </Typography>
            }
          />
        </RadioGroup>
      </div>

      <Box
        sx={{
          display: "flex",
          justifyContent: 'space-between',
          alignItems: "center",
          marginTop: "20px",
          marginBottom: "10px",
        }}>
        <Typography
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "21px",
            textAlign: "left",
          }}>
          {accessType === "limited-access"
                ? `User with access (${userData.length > 0 ? userData.length : 0})`
                : ""}
        </Typography>
        <Box sx={{ display: "flex", gap: "10px", ml: "auto" }}>
        {accessType === "limited-access" && !showTable && (
          <Box>
          <Button
            variant='contained'
            onClick={handleSortClick}
            sx={{
              backgroundColor: "white",
              color: "gray",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "12px",
              border: "1px solid lightgray",
              borderRadius: "6px",
              height: "32px",
              "&:hover": {
                backgroundColor: "lightgray",
              },
              textTransform: "none",
            }}>
             {sortBy} <ArrowDropDown fontSize="small" />
          </Button>
        <Menu
          anchorEl={anchorSortEl}
          open={Boolean(anchorSortEl)}
          onClose={() => setAnchorSortEl(null)}>
          <MenuItem onClick={() => handleSortSelect("Email ID")}>Email ID</MenuItem>
          <MenuItem onClick={() => handleSortSelect("Name")}>Name</MenuItem>
          <MenuItem onClick={() => handleSortSelect("Added on")}>Added on</MenuItem>
        </Menu>
        </Box>
        )}
        {accessType === "limited-access" && !showTable && (
          <Button
            variant='contained'
            onClick={handleAddMembersClick}
            sx={{
              backgroundColor: "red",
              color: "white",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "12px",
              height: "32px",
              justifyContent: 'flex-end',
              "&:hover": {
                backgroundColor: "red",
              },
              textTransform: "none",
            }}>
            Log
          </Button>
        )}
        {accessType === "limited-access" && showTable && (
          <Button
            variant='contained'
            sx={{
              backgroundColor: "red",
              color: "white",
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "12px",
              height: "32px",
              lineHeight: "14.52px",
              width: "100px",
              textAlign: "right",
              "&:hover": {
                backgroundColor: "red",
              },
              textTransform: "none",
            }}
            onClick={handleAddMembersClick}>
            Mail
          </Button>
        )}
      </Box>
      </Box>
      {accessType === "limited-access" && !showTable && <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
      <UserProfileCard user={userData} users={sortedUsers} />
    </Box>}
      {accessType === "limited-access" &&  !showTable && <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
          marginBottom: "10px",
        }}><Typography sx={{mt: "", textAlign: "left" }}>Invite User</Typography></Box>}
      {!showTable ? (
        <Card
          style={{
            //padding: "24px",
            overflow: "visible",
            textAlign: "center",
            width: "100%",
            //maxWidth: "1200px",
            //margin: "20px auto",
          }}>
          {accessType === "no-access" && (
            <div>
              <Box style={{ marginTop: "100px" }}>
                <NoAccessIcon />
              </Box>
              <Typography
                variant='h6'
                style={{
                  margin: "20px",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "19.36px",
                  textAlign: "center",
                }}>
                No Access
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "16.94px",
                  textAlign: "center",
                  marginBottom: "100px",
                }}>
                Only the creator can view this plan.
                <br />
                Other users are restricted from accessing it.
              </Typography>
            </div>
          )}

          {accessType === "full-access" && (
            <div style={{ padding: "16px" }}>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "21px",
                  textAlign: "left",
                }}>
                Invite members with a link
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  height: "32px",
                  alignItems: "center",
                  backgroundColor: "#FFF6E5",
                  padding: "4px 12px",
                  mt: "8px",
                  mb: "8px",
                  borderRadius: "8px",
                }}>
                <InfoIcon
                  sx={{ backgroundColor: "#FFA500", fontSize: 20, mr: 1 }}
                />
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "16px",
                    ml: 1,
                  }}>
                  Note:
                  <Typography
                    component='span'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "16px",
                      textAlign: "left",
                    }}>
                    &nbsp;Anyone with the link can access this file. Please do
                    not share confidential information.
                  </Typography>
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "21px",
                  textAlign: "left",
                  mb: 2
                }}>
                Set Link Expiry
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <DateRangePicker
                  dateRange={dateRange}
                  setDateRange={(newDateRange) => {
                    setDateRange(newDateRange);
                    // You can add any additional logic here when date range changes
                  }}
                  allowFutureDates={true}
                  highlightColor='red'
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "32px",
                  mt: "10px",
                }}>
<TextField
  fullWidth
  variant='outlined'
  InputProps={{
    readOnly: true,
    sx: { height: "32px" },
    startAdornment: (
      <Typography
        sx={{
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          fontWeight: 400,
          lineHeight: "14.52px",
          width: "400px",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}>
        {linkToCopy}
      </Typography>
    ),
  }}
  sx={{ flexGrow: 1 }}
/>

                <Button
                  variant='contained'
                  onClick={() => {
                    handleGenerateLink();
                    handleCopyLink();
                  }}
                  sx={{
                    backgroundColor: "red",
                    height: "32px",
                    ml: "10px",
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "red",
                    },
                  }}>
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "14.52px",
                      textAlign: "left",
                      color: "#FFFFFF",
                    }}>
                    {isCopied ? "Copied!" : "Copy Link"}{" "}
                  </Typography>
                  {!isCopied && (
                    <ContentCopyRounded
                      sx={{ fontSize: "14px", ml: "5px", color: "#FFFFFF" }}
                    />
                  )}
                </Button>
              </Box>
            </div>
          )}

          {accessType === "limited-access" && (
            <div style={{ padding: "16px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "32px",
                  mt: "30px",
                }}>
                  <Autocomplete
                  multiple
                  fullWidth
                  freeSolo
                  options={emailOptions}
                  value={email}
                  getOptionLabel={(option) => option.label}
                  onChange={handleAutocompleteChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      variant="outlined"
                      placeholder="Invite members by mail"
                      onBlur={handleAutocompleteBlur}
                      //error={errors.email ? true : false}
                      //helperText={errors.email}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          minHeight: email.length ? "auto" : "48px",
                          padding: "8px",
                          ...(errors.email && {
                            borderColor: 'red',
                            '&.Mui-focused': {
                              borderColor: 'red',
                            },
                          }),
                        },
                      }}
                      sx={{
                        flexGrow: 1,
                        fontFamily: "Inter, sans-serif",
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "14.52px",
                      }}
                    />
                  )}
                  ListboxProps={{
                    sx: {
                      maxHeight: "200px", // Control max height of dropdown options
                      overflowY: "auto",
                    },
                  }}
                  sx={{
                    "& .MuiAutocomplete-tag": {
                      maxWidth: "calc(100% - 24px)", // Keep chips within bounds
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    "& .MuiAutocomplete-inputRoot": {
                      flexWrap: "wrap", // Allow wrapping of selected items
                      paddingTop: "8px",
                      paddingBottom: "8px",
                    },
                  }}
                />
                <Button
                  variant='contained'
                  sx={{
                    backgroundColor: "red",
                    height: "32px",
                    ml: "10px",
                    width: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                    "&:hover": {
                      backgroundColor: "red",
                    },
                    textTransform: "none",
                  }}
                  onClick={() =>
                    handleSendInvite(email, subject, message, file)
                  }>
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: "14.52px",
                      textAlign: "left",
                      color: "#FFFFFF",
                    }}>
                    Send Invite
                  </Typography>
                </Button>
              </Box>
              {errors.email && (
                <Typography sx={{ color: "red", fontSize: "12px", mt: "15px" }}>
                  {errors.email}
                </Typography>
              )}

              <Box sx={{ mt: "30px" }}>
                <Typography sx={{ mt: "10px", textAlign: "left" }}>
                  Subject
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "32px",
                    mt: "10px",
                  }}>
                  <TextField
                    fullWidth
                    variant='outlined'
                    placeholder='Share Plan'
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    InputProps={{
                      sx: { height: "32px", backgroundColor: "#FAFAFA" },
                    }}
                    sx={{
                      flexGrow: 1,
                      height: "32px",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "14.52px",
                    }}
                  />
                </Box>
                {errors.subject && (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errors.subject}
                  </Typography>
                )}
              </Box>

              <Box>
                <Typography sx={{ mt: "5px", textAlign: "left", mb: "5px" }}>
                  Message
                  <span style={{ color: "red" }}>*</span>
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "130px",
                  }}>
                  <TextField
                    fullWidth
                    variant='outlined'
                    placeholder=''
                    multiline
                    rows={6}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    InputProps={{
                      sx: { height: "133px", backgroundColor: "#FAFAFA" },
                    }}
                    sx={{
                      flexGrow: 1,
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "14.52px",
                    }}
                  />
                </Box>
                {errors.message && (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errors.message}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  mt: "10px",
                  width: "200px",
                  height: "32px",
                  borderRadius: "4px",
                }}>
                <input
                  type='file'
                  id='file-upload'
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  accept='*/*'
                />
                <Button
                  variant='contained'
                  startIcon={<AttachFileRoundedIcon />}
                  onClick={handleButtonClick}
                  sx={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    backgroundColor: "#FAFAFA",
                    color: "black",
                    border: "1px solid #474747",
                    boxShadow: "none",
                    fontSize: "12px",
                    "&:hover": {
                      backgroundColor: "#FAFAFA",
                      border: "1px solid black",
                      color: "black",
                      boxShadow: "none",
                    },
                  }}>
                  Add Attachment
                </Button>
                <Typography
                  variant='body2'
                  sx={{
                    ml: "10px",
                    color: "#888",
                    fontSize: "12px",
                    fontFamily: "Inter, sans-serif",
                  }}>
                  (Optional)
                </Typography>
              </Box>
              {file && (
                <Typography
                  sx={{ mt: "5px", fontSize: "12px", color: "black" }}>
                  Selected File: {file.name}
                </Typography>
              )}
            </div>
          )}
        </Card>
      ) : (
        <div
          style={{
            padding: "24px",
            textAlign: "center",
            width: "100%",
            maxWidth: "1100px",
            margin: "20px auto",
          }}>
          <TableContainer component={Paper} style={{
      overflowX: "auto",
    }}>
          <div>
            <Table sx={{ minWidth: 150 }} aria-label='user table'>
              <TableHead sx={{ backgroundColor: "#e0eaff", height: "50px" }}>
                <TableRow>
                  <TableCell sx={cellStyle}>Email ID</TableCell>
                  <TableCell sx={cellStyle}>Shared On</TableCell>
                  <TableCell sx={cellStyle}>Joined On</TableCell>
                  <TableCell sx={cellStyle}>Invite Status</TableCell>
                 <TableCell sx={cellStyle}>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody sx={{ height: "10px" }}>
                {mailTable.map((user, index) => (
                  <TableRow key={user.user_id}>
                    <TableCell sx={dataStyle}>{user.email}</TableCell>
                    <TableCell sx={dataStyle}>
                      {" "}
                      {formatDate(user.createdAt)}
                    </TableCell>
                    <TableCell sx={dataStyle}>
                      {" "}
                      {formatDate(user.updatedAt)}
                    </TableCell>
                    <TableCell sx={dataStyle}>
                      <Button
                        variant='outlined'
                        sx={{
                          color:
                            user.invite_status === "Accepted"
                              ? "green"
                              :
                              "orange",
                          borderColor:
                            user.invite_status === "Accepted"
                              ? "green"
                              :
                              "orange",
                          //color: "#fff",
                          textTransform: "none",
                          borderRadius: "12px",
                          fontSize: "12px",
                          padding: "2px 8px",
                          cursor: "default",
                        }}>
                        {user.invite_status}
                      </Button>
                    </TableCell>
<TableCell>
                      <IconButton aria-label='more options'>
                        <MoreVertIcon
                          sx={{ height: "20px", width: "20px" }}
                          onClick={(event) =>
                            handleActionOpen(event, user.id, user)
                          }
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Popover
       id={id}
       open={open}
       anchorEl={anchorEl}
       onClick={handleCloseAction}
       anchorOrigin={{
         vertical: "bottom",
         horizontal: "right",
       }}
       transformOrigin={{
         vertical: "top",
         horizontal: "right",
       }}>
       <Box sx={{ p: 1, width: "130px" }}>
         <Button
           onClick={handleResendMail}
           fullWidth
           sx={{
             justifyContent: "flex-start",
             textTransform: "none", // to keep the text lowercase

             color: "black", // you can adjust color as needed
           }}>
           <MailIcon fontSize='small' sx={{ mr: 1 }} />
           <Typography
             id='view-user'
             variant='body1'
             sx={{
               fontFamily: "Inter",
               fontSize: "12px",
               fontWeight: 500,
               lineHeight: "14.52px",
             }}>
             Resend Mail
           </Typography>
         </Button>
         <Button
           onClick={handleDeleteUser}
           fullWidth
           sx={{
             justifyContent: "flex-start",
             textTransform: "none",

             color: "black",
           }}>
            <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
           <Typography
             id='edit-user'
             variant='body1'
             sx={{
               fontFamily: "Inter",
               fontSize: "12px",
               fontWeight: 500,
               lineHeight: "14.52px",
             }}>
             Remove User
           </Typography>
         </Button>

       </Box>
     </Popover>
            </div>
          </TableContainer>
        </div>
      )}
<GenericDialog
        open={open1}
        onClose={handleClose}
        title='Change Plan Access'
        content={
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "23.5px",
                textAlign: "left",
              }}>
              Change Plan Access
            </div>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
                textAlign: "left",
                marginTop: "12px",
              }}>Are you sure you want to change access for the current plan?</div>
            <Box
                sx={{
                  display: "flex",
                  height: "40px",
                  alignItems: "center",
                  backgroundColor: "#FFF6E5",
                  padding: "8px 12px",
                  mt: "10px",
                  mb: "10px",
                  borderRadius: "8px",
                }}>
                <InfoIcon
                  sx={{ backgroundColor: "#FFA500", fontSize: 20, mr: 1 }}
                />
                <Typography
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    ml: 1,
                  }}>
                  Note:
                  {accessType === "full-access" && <Typography 
     component='span'
     sx={{
       fontFamily: "Inter, sans-serif",
       fontSize: "12px",
       fontWeight: 400,
       lineHeight: "20px",
       textAlign: "left",
     }}>&nbsp;Changing to <strong style={{ fontWeight: 700 }}>"{accessType.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}"</strong> will grant plan access to users who have the plan link.
  </Typography>}
  {accessType === "limited-access" && <Typography 
     component='span'
     sx={{
       fontFamily: "Inter, sans-serif",
       fontSize: "12px",
       fontWeight: 400,
       lineHeight: "20px",
       textAlign: "left",
     }}>&nbsp;Changing to <strong style={{ fontWeight: 700 }}>"{accessType.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}"</strong> will revoke plan access for all users. Only you will be able to view the plan.
  </Typography>}
  {accessType === "no-access" && <Typography 
     component='span'
     sx={{
       fontFamily: "Inter, sans-serif",
       fontSize: "12px",
       fontWeight: 400,
       lineHeight: "20px",
       textAlign: "left",
     }}>&nbsp;Changing to <strong style={{ fontWeight: 700 }}>"{accessType.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}"</strong> will revoke plan access for all users. Only you will be able to view the plan.
  </Typography>}  
                </Typography>
              </Box>
            <Box display='flex' p={1}>
              <Button
                variant='contained'
                fullWidth
                onClick={handleClose}
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FAFAFA",
                  "&:hover": {
                    backgroundColor: "#FAFAFA",
                  },
                  padding: "6px 16px",
                  color: "black",
                  border: "1px solid black",

                  marginRight: "10px",
                }}>
                Cancel
              </Button>
              <Button
                variant='contained'
                fullWidth
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FF2800",
                  padding: "6px 16px",
                  "&:hover": {
                    backgroundColor: "#FF2800",
                  },
                }}
                onClick={handleChangeAccess}>
                Change Access
              </Button>
            </Box>
          </>
        }
        maxWidth='xs'
        button={<Button onClick={handleClose}>Close</Button>}
        noBackGround={false}
        fullScreen={false}
      />
    </div>

  );
};

export default ProjectSharePlan;
